import React, {useEffect, useLayoutEffect, useRef, useState} from "react";
import Wrapper from "../../components/Common/Wrapper";
import {useGetPostsQuery, useGetThemeOptionsQuery} from "../../services/themeApi";
import ContentRealization from "./ContentRealization";
import Button from "../../components/Buttons/Button/Button";
import "./Realizations.scss";
import Loader from "../../components/Loader/Loader";
import {toggleDescriptions} from "../../helpers/toggle-descriptions";
import CollaborationBanner from "../../components/CollaborationBanner/CollaborationBanner";

const Realizations = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [isTransitioning, setIsTransitioning] = useState(false);

    const {data, error, isLoading} = useGetPostsQuery(
        {
            postType: "realizacje",
            perPage: 12,
            page: currentPage,
            taxonomy: "typ-realizacji, uzyta-technologia",
        },
        {refetchOnMountOrArgChange: false}
    );

    const {data: themeOptions} = useGetThemeOptionsQuery();

    const posts = data?.posts || [];
    const totalPages = data?.total_pages || 1;

    const descriptionToggleRef = useRef(null);

    useEffect(() => {
        const timer = setTimeout(() => {
            window.scrollTo({top: 0, behavior: "smooth"});
        }, 500);

        return () => clearTimeout(timer);
    }, [currentPage]);


    useEffect(() => {
        // console.log('Rendering component');
        // console.log('descriptionToggleRef:', descriptionToggleRef);
        // console.log('descriptionToggleRef.current:', descriptionToggleRef.current);

        const timer = setTimeout(() => {
            if (descriptionToggleRef.current) {
                // console.log('descriptionToggleRef is ready after delay');
                toggleDescriptions(descriptionToggleRef.current);
            } else {
                // console.log('descriptionToggleRef is still null after delay');
            }
        }, 100); // Opóźnienie 100 ms

        return () => clearTimeout(timer);
    }, [themeOptions]);


    const handlePageChange = (newPage) => {
        setIsTransitioning(true);
        setTimeout(() => {
            setCurrentPage(newPage);
            setIsTransitioning(false);
        }, 300); // Delay for smooth transition
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            handlePageChange(currentPage + 1);
        }
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            handlePageChange(currentPage - 1);
        }
    };

    if (isLoading) {
        return (
            <Wrapper>
                <Loader loading={true} size={60} color="#ff5733"/>
            </Wrapper>
        );
    }

    return (
        <Wrapper>
            <div className="realizations-main">
                <div className="realizations-main--title">
                    <h1>
                        {themeOptions?.realization_title || "Realizacje"}
                        <span>{themeOptions?.realization_title_2 || "Site-Art"}</span>
                    </h1>
                </div>
                <div
                    className={`realizations-main--inside ${isTransitioning ? "transitioning" : ""}`}
                >
                    {error && <p className="error">Error: {error.message}</p>}
                    {!error && posts.length > 0 && (
                        posts.map((post) => (
                            <ContentRealization key={post.id} post={post}/>
                        ))
                    )}
                    {!error && posts.length === 0 && <p>Brak realizacji.</p>}
                </div>
                {totalPages > 1 && (
                    <div className="pagination-controls">
                        <Button
                            onClick={handlePreviousPage}
                            classes={["btn", "btn-transparent", "white", "pagination-button--prev", "pagination-button"]}
                            text="Wstecz"
                            hasIcon={false}
                            type="button"
                            disabled={currentPage === 1 || isTransitioning}
                        />
                        <span>Strona {currentPage} z {totalPages}</span>
                        <Button
                            onClick={handleNextPage}
                            classes={["btn", "btn-transparent", "white", "pagination-button--next", "pagination-button"]}
                            text="Dalej"
                            hasIcon={false}
                            type="button"
                            disabled={currentPage === totalPages || isTransitioning}
                        />
                    </div>
                )}
                <CollaborationBanner themeOptions={themeOptions}/>

                {themeOptions && (
                    <div className="description-toggle realizations-main--description" ref={descriptionToggleRef}>
                        <div
                            className="description-toggle--inside realization-main--description"
                            dangerouslySetInnerHTML={{__html: themeOptions?.realization_desc}}
                        />
                        <Button
                            id="toggleButton"
                            onClick={() => console.log('Toggle clicked')}
                            classes={[
                                "btn",
                                "btn-submit",
                                "btn-transparent",
                                "left-to-right-animate",
                                "white",
                            ]}
                            text="Więcej"
                            hasIcon={false}
                            type="button"
                        />
                    </div>
                )}
            </div>

        </Wrapper>
    );
};

export default Realizations;
